import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import usePaginator from "../../../../theme/Component/usePaginator";
import { Singleton } from "../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { _HealthScope, _HealthServiceProvision, _MeansAdministration, _PharmaCumState, _PharmaRecordState } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { AccountEditor } from "../../../../editor/AccountEditor";
import { HealthTechnologyTypeEditor } from "../../../../GestionTerceros/AbstractAccount/HealthTechnologyType/HealthTechnologyTypeEditor";
import { HealthIDEditor } from "../../../../admin/configuracion/HealthID/HealthIDEditor";
import { HealthMedicationEditor } from "../HealthMedicationEditor";
import { MedicalDeviceEditor } from "../../../../GestionTerceros/AbstractAccount/MedicalDevice/MedicalDeviceEditor";
import { BodyComponentEditor } from "../../../../GestionTerceros/AbstractAccount/BodyComponent/BodyComponentEditor";
import { HealthProductEditor } from "../../../../GestionTerceros/AbstractAccount/HealthProduct/HealthProductEditor";
import { HealthTechnologyPurposeEditor } from "../../../../GestionTerceros/AbstractAccount/HealthTechnologyPurpose/HealthTechnologyPurposeEditor";
import { InputDate } from "../../../../theme/Input/InputDate";
import { PharmaPresentationEditor } from "../PharmaPresentation/PharmaPresentationEditor";
import { MeansAdministrationEditor } from "../MeansAdministration/MeansAdministrationEditor";
import { HealthTimeUnitEditor } from "../../../../GestionTerceros/AbstractAccount/HealthTimeUnit/HealthTimeUnitEditor";
import { _single } from "../../../../../core/services/dataBean/EntityCatalog";

interface Props {
    idClinicalDocument: number;
    issueDate: any
}

export const HealthServiceProvision = ({ idClinicalDocument, issueDate }: Props) => {

    const sev = useDataBean(_HealthServiceProvision);
    const paginador = usePaginator();
    const [Health, setHealth] = useState<any>(null);
    const [NameSelect, setNameSelect] = useState<any>(null);
    const [regexStr, setregexStr] = useState<any>(null)
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [Account, setAccount] = useState<number>(null)
    const [saved, setSaved] = useState<any>(null)
    const [form, setForm] = useState<any>({
        HealthTechnologyTypeName: null,
        IDHealthTechnologyType: null,
        IDHealthMedication: null,
        HealthMedicationName: null,
        IDMedicalDevice: null,
        MedicalDeviceName: null,
        IDBodyComponent: null,
        BodyComponentName: null,
        IDHealthProduct: null,
        HealthProductName: null,
        IDHealthTechnologyPurpose: null,
        HealthTechnologyPurposeName: null
    })
    const [modalsoporte, setModalsoporte] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalcreate, setModalcreate] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [idClinicalDocument, issueDate, paginador.page])

    const getLista = () => {

        sev.instance.getHealthServiceProvisionCatalog(Account, idClinicalDocument, issueDate, form.IDHealthTechnologyType, Health, form.IDHealthMedication, form.IDMedicalDevice, form.IDBodyComponent, form.IDHealthProduct, form.IDHealthTechnologyPurpose, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    let x = resp.List;
                    x.forEach((user) => {
                        user.DataBeanProperties.TechType = (user.DataBeanProperties.HealthTechnologyTypeCode ?? "") + "-" + (user.DataBeanProperties.HealthTechnologyTypeName ?? "");
                        user.DataBeanProperties.Procces = (user.DataBeanProperties.HealthIDJsonCode ?? "") + "-" + (user.DataBeanProperties.HealthIDName ?? "");
                        user.DataBeanProperties.Med = (user.DataBeanProperties.HealthMedicationRecord ?? "") + "-" + (user.DataBeanProperties.HealthMedicationName ?? "")
                            + "-" + (user.DataBeanProperties.HealthMedicationDescription ?? "") + "-" + (user.DataBeanProperties.HealthMedicationMedicalRegitration ?? "") + "-" + (user.DataBeanProperties.HealthMedicationCumRecord ?? "");
                        user.DataBeanProperties.Dev = (user.DataBeanProperties.MedicalDeviceCode ?? "") + "-" + (user.DataBeanProperties.MedicalDeviceName ?? "");
                        user.DataBeanProperties.Body = (user.DataBeanProperties.BodyComponentType ?? "") + "-" + (user.DataBeanProperties.BodyComponentCode ?? "") + "-" + (user.DataBeanProperties.BodyComponentName ?? "");
                        user.DataBeanProperties.Hlt = (user.DataBeanProperties.HealthProductCode ?? "") + "-" + (user.DataBeanProperties.HealthProductName ?? "");
                        user.DataBeanProperties.Pharma = (user.DataBeanProperties.PharmaPresentationCode ?? "") + "-" + (user.DataBeanProperties.PharmaPresentationName ?? "");
                        user.DataBeanProperties.Means = (user.DataBeanProperties.MeansAdministrationCode ?? "") + "-" + (user.DataBeanProperties.MeansAdministrationName ?? "");
                        user.DataBeanProperties.Time = (user.DataBeanProperties.HealthTimeUnitCode ?? "") + "-" + (user.DataBeanProperties.HealthTimeUnitName ?? "");
                        user.DataBeanProperties.Employye = (user.DataBeanProperties.EmployeeNit ?? "") + "-" + (user.DataBeanProperties.EmployeeName1 ?? "")
                            + "-" + (user.DataBeanProperties.EmployeeName2 ?? "") + "-" + (user.DataBeanProperties.EmployeeSurname1 ?? "") + "-" + (user.DataBeanProperties.EmployeeSurname2 ?? "");
                    });
                    setLista(x)
                }
            }
        )

    }
    const create = () => {
        setNameSelect(null)
        sev.setBean({

        });
        setModalcreate({ ...modalcreate, "view": true });
    }
    const deleteItem = () => {
        sev.instance.deleteVoid(sev.bean.IDHealthServiceProvision).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {

        sev.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
                console.log('servicio dos', resp)
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const addHealthServiceProvision = () => {

        sev.instance.addHealthServiceProvision(idClinicalDocument, issueDate, sev.bean.IDHealthTechnologyType, _single.getAccountID()).then(
            (resp: any) => {
                console.log('servicio uno', resp)
                const temp = resp;
                sev.updateCustonBean({
                    ...temp, ...sev.bean
                }).then(
                    (resp: any) => {
                        console.log('servicio dos', resp)
                        getLista()
                        setModalcreate({ ...modalcreate, "view": false });
                    }
                ).catch(err => {
                    toast.error(err);
                })
            }
        ).catch(err => {
            toast.error(err);
        })

    }


    const head = [
        { title: 'ID', property: 'IDHealthServiceProvision', visible: true },
        { title: 'ID Evento Clínico', property: 'IDClinicalDocument', visible: true },
        { title: 'Fecha Evento Clínico', property: 'IssueDate', visible: true },
        { title: 'Tecnología Aplicada', property: 'TechType', visible: true },
        { title: 'Tipo Tecnología', property: 'TechnologyTypeName', visible: true },
        { title: 'Tecnología en Salud', property: 'HealthServiceProvisionName', visible: true },
        { title: 'Propósito', property: 'IDHealthTechnologyPurpose', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Usuario Logueado', property: 'Employye', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }
    return (

        <div className="row">
            <div className="col-md-12">
                <label>Tecnologías en Salud</label>
            </div>
            <div className="col-md-4">
                <AccountEditor idAccount={Account} onChange={(e) => { setAccount(e.IDAccount) }} label="Empleado" />
            </div>
            <div className="col-md-4">
                <HealthTechnologyTypeEditor render={form.HealthTechnologyTypeName} idSelector={form.IDHealthTechnologyType} onChange={(e) => { setForm({ ...form, "IDHealthTechnologyType": e.IDHealthTechnologyType, "HealthTechnologyTypeName": e.Name }) }} label='Tecnología Aplicada' returnType="Object" />
            </div>
            <div className="col-md-4">
                <HealthIDEditor render={NameSelect} tipoPresupuesto={25} id={null} edit={true} onSelect={(item) => { console.log(item); setHealth(item); }} onSelectName={(item) => { console.log(item); setNameSelect(item); }} />
            </div>
            <div className="col-md-4">
                <HealthMedicationEditor render={form.HealthMedicationName} idSelector={form.IDHealthMedication} onChange={(e) => { setForm({ ...form, "IDHealthMedication": e.IDHealthMedication, "HealthMedicationName": e.Name }) }} returnType="Object" />
            </div>
            <div className="col-md-4">
                <MedicalDeviceEditor render={form.MedicalDeviceName} idSelector={form.IDMedicalDevice} onChange={(e) => { setForm({ ...form, "IDMedicalDevice": e.IDMedicalDevice, "MedicalDeviceName": e.Name }) }} returnType="Object" />
            </div>
            <div className="col-md-4">
                <BodyComponentEditor render={form.BodyComponentName} idSelector={form.IDBodyComponent} onChange={(e) => { setForm({ ...form, "IDBodyComponent": e.IDBodyComponent, "BodyComponentName": e.Name }) }} returnType="Object" />
            </div>
            <div className="col-md-4">
                <HealthProductEditor render={form.HealthProductName} idSelector={form.IDHealthProduct} onChange={(e) => { setForm({ ...form, "IDHealthProduct": e.IDHealthProduct, "HealthProductName": e.Name }) }} returnType="Object" />
            </div>
            <div className="col-md-4">
                <HealthTechnologyPurposeEditor render={form.HealthTechnologyPurposeName} idSelector={form.IDHealthTechnologyPurpose} onChange={(e) => { setForm({ ...form, "IDHealthTechnologyPurpose": e.IDHealthTechnologyPurpose, "HealthTechnologyPurposeName": e.Name }) }} returnType="Object" />
            </div>
            <div className="col-md-4">
                <label>Búsqueda por Texto</label>
                <input type="text" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
            </div>
            <div className="col-md-4 mt-4 p-2">
                <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
            </div>
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={sev.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                <Modal modal={modalcreate} updateModal={setModalcreate} eventModal={addHealthServiceProvision}>
                    <div className="row">
                        <div className="col-md-12">
                            <HealthTechnologyTypeEditor render={sev.bean.HealthTechnologyTypeName} idSelector={sev.bean.IDHealthTechnologyType} onChange={(e) => { sev.setBean({ ...sev.bean, "IDHealthTechnologyType": e.IDHealthTechnologyType, "HealthTechnologyTypeName": e.Name, "TechnologyType": e.TechnologyType }) }} label='Tecnología Aplicada' returnType="Object" />
                        </div>
                        {sev.bean.TechnologyType == 25 && (
                            <>
                                <div className="col-md-12">
                                    <label>PROCEDIMIENTOS</label>
                                </div>
                                <div className="col-md-12">
                                    <HealthIDEditor render={sev.bean.HealthIDName || NameSelect} tipoPresupuesto={25} id={null} edit={true} onSelect={(e) => { sev.setBean({ ...sev.bean, "IDLnProcedures": e }) }} onSelectName={(item) => { console.log(item); setNameSelect(item); }} />
                                </div>
                            </>
                        )}
                        {sev.bean.TechnologyType == 26 && (
                            <>
                                <div className="col-md-12">
                                    <label>MEDICAMENTOS</label>
                                </div>
                                <div className="col-md-6">
                                    <HealthMedicationEditor render={sev.bean.HealthMedicationName} idSelector={sev.bean.IDHealthMedication} onChange={(e) => { sev.setBean({ ...sev.bean, "IDHealthMedication": e.IDHealthMedication, "HealthMedicationName": e.Name }) }} returnType="Object" />
                                </div>
                                <div className="col-md-6">
                                    <InputDate label="Fecha de Prescripción" name="PrescriptionDate" value={sev.bean.PrescriptionDate} setDate={(e: any) => { sev.setBean({ ...sev.bean, 'PrescriptionDate': e }) }} ></InputDate>
                                </div>
                                <div className="col-md-6">
                                    <label>Cantidad de Medicamento Prescrito</label>
                                    <input type="text" name="HealthMedicationQuantity" className="form-control" value={sev.bean.HealthMedicationQuantity} onChange={sev.handleChange} />
                                </div>
                                <div className="col-md-6">
                                    <PharmaPresentationEditor render={sev.bean.PharmaPresentationName} idSelector={sev.bean.IDPharmaPresentation} onChange={(e) => { sev.setBean({ ...sev.bean, "IDPharmaPresentation": e.IDPharmaPresentation, "PharmaPresentationName": e.Name }) }} label="Presentación Farmaceutica" returnType="Object" />
                                </div>
                                <div className="col-md-6">
                                    <MeansAdministrationEditor render={sev.bean.MeansAdministrationName} idSelector={sev.bean.IDMeansAdministration} onChange={(e) => { sev.setBean({ ...sev.bean, "IDMeansAdministration": e.IDMeansAdministration, "MeansAdministrationName": e.Name }) }} label="Medio de Administración" returnType="Object" />
                                </div>
                                <div className="col-md-6">
                                    <HealthTimeUnitEditor render={sev.bean.HealthTimeUnitName} idSelector={sev.bean.IDHealthTimeUnitTotalDuration} onChange={(e) => { sev.setBean({ ...sev.bean, "IDHealthTimeUnitTotalDuration": e.IDHealthTimeUnit, "HealthTimeUnitName": e.Name }) }} label="Unidades de Tiempo" returnType="Object" />
                                </div>
                                <div className="col-md-6">
                                    <label>Frecuencia de Administración</label>
                                    <input type="text" name="TimeQuantityFrecuency" className="form-control" value={sev.bean.TimeQuantityFrecuency} onChange={sev.handleChange} />
                                </div>
                                <div className="col-md-12">
                                    <label>Descripción Común del Medicamento</label>
                                    <textarea name="CommonMedicationDescription" className="form-control" value={sev.bean.CommonMedicationDescription} onChange={sev.handleChange} />
                                </div>
                            </>
                        )}
                        {sev.bean.TechnologyType == 34 && (
                            <>
                                <div className="col-md-12">
                                    <label>DISPOSITIVO MÉDICO</label>
                                </div>
                                <div className="col-md-12">
                                    <MedicalDeviceEditor render={sev.bean.MedicalDeviceName} idSelector={sev.bean.IDMedicalDevice} onChange={(e) => { sev.setBean({ ...sev.bean, "IDMedicalDevice": e.IDMedicalDevice, "MedicalDeviceName": e.Name }) }} returnType="Object" />
                                </div>
                            </>
                        )}
                        {sev.bean.TechnologyType == 35 && (
                            <>
                                <div className="col-md-12">
                                    <label>COMPONENTES DEL CUERPO</label>
                                </div>
                                <div className="col-md-12">
                                    <BodyComponentEditor render={sev.bean.BodyComponentName} idSelector={sev.bean.IDBodyComponent} onChange={(e) => { sev.setBean({ ...sev.bean, "IDBodyComponent": e.IDBodyComponent, "BodyComponentName": e.Name }) }} returnType="Object" />
                                </div>
                            </>
                        )}
                        {sev.bean.TechnologyType == 27 && (
                            <>
                                <div className="col-md-12">
                                    <label>SUMINISTROS</label>
                                </div>
                                <div className="col-md-12">
                                    <HealthProductEditor render={sev.bean.HealthProductName} idSelector={sev.bean.IDHealthProduct} onChange={(e) => { sev.setBean({ ...sev.bean, "IDHealthProduct": e.IDHealthProduct, "HealthProductName": e.Name }) }} returnType="Object" />
                                </div>
                            </>
                        )}
                        {sev.bean.TechnologyType == 28 && (
                            <>
                                <div className="col-md-12">
                                    <label>OTROS</label>
                                </div>
                                <div className="col-md-12">
                                    <label>Código Otras Tecnologías</label>
                                    <input type="text" name="OtherTechologyCode" className="form-control" value={sev.bean.OtherTechologyCode} onChange={sev.handleChange} />
                                </div>
                            </>
                        )}
                        <div className="col-md-12">
                            <HealthTechnologyPurposeEditor render={sev.bean.HealthTechnologyPurposeName} idSelector={sev.bean.IDHealthTechnologyPurpose} onChange={(e) => { sev.setBean({ ...sev.bean, "IDHealthTechnologyPurpose": e.IDHealthTechnologyPurpose, "HealthTechnologyPurposeName": e.Name }) }} returnType="Object" />
                        </div>
                        <div className="col-md-12">
                            <label>Descripción</label>
                            <textarea name="Description" className="form-control" value={sev.bean.Description} onChange={sev.handleChange} />
                        </div>
                    </div>
                </Modal>
                <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                    <div className="row">
                        {sev.bean.TechnologyType == 25 && (
                            <>
                                <div className="col-md-12">
                                    <label>PROCEDIMIENTOS</label>
                                </div>
                                <div className="col-md-12">
                                    <HealthIDEditor render={sev.bean.HealthIDName || NameSelect} tipoPresupuesto={25} id={null} edit={true} onSelect={(e) => { sev.setBean({ ...sev.bean, "IDLnProcedures": e }) }} onSelectName={(item) => { console.log(item); setNameSelect(item); }} />
                                </div>
                            </>
                        )}
                        {sev.bean.TechnologyType == 26 && (
                            <>
                                <div className="col-md-12">
                                    <label>MEDICAMENTOS</label>
                                </div>
                                <div className="col-md-6">
                                    <HealthMedicationEditor render={sev.bean.HealthMedicationName} idSelector={sev.bean.IDHealthMedication} onChange={(e) => { sev.setBean({ ...sev.bean, "IDHealthMedication": e.IDHealthMedication, "HealthMedicationName": e.Name }) }} returnType="Object" />
                                </div>
                                <div className="col-md-6">
                                    <InputDate label="Fecha de Prescripción" name="PrescriptionDate" value={sev.bean.PrescriptionDate} setDate={(e: any) => { sev.setBean({ ...sev.bean, 'PrescriptionDate': e }) }} ></InputDate>
                                </div>
                                <div className="col-md-6">
                                    <label>Cantidad de Medicamento Prescrito</label>
                                    <input type="text" name="HealthMedicationQuantity" className="form-control" value={sev.bean.HealthMedicationQuantity} onChange={sev.handleChange} />
                                </div>
                                <div className="col-md-6">
                                    <PharmaPresentationEditor render={sev.bean.PharmaPresentationName} idSelector={sev.bean.IDPharmaPresentation} onChange={(e) => { sev.setBean({ ...sev.bean, "IDPharmaPresentation": e.IDPharmaPresentation, "PharmaPresentationName": e.Name }) }} label="Presentación Farmaceutica" returnType="Object" />
                                </div>
                                <div className="col-md-6">
                                    <MeansAdministrationEditor render={sev.bean.MeansAdministrationName} idSelector={sev.bean.IDMeansAdministration} onChange={(e) => { sev.setBean({ ...sev.bean, "IDMeansAdministration": e.IDMeansAdministration, "MeansAdministrationName": e.Name }) }} label="Medio de Administración" returnType="Object" />
                                </div>
                                <div className="col-md-6">
                                    <HealthTimeUnitEditor render={sev.bean.HealthTimeUnitName} idSelector={sev.bean.IDHealthTimeUnitTotalDuration} onChange={(e) => { sev.setBean({ ...sev.bean, "IDHealthTimeUnitTotalDuration": e.IDHealthTimeUnit, "HealthTimeUnitName": e.Name }) }} label="Unidades de Tiempo" returnType="Object" />
                                </div>
                                <div className="col-md-6">
                                    <label>Frecuencia de Administración</label>
                                    <input type="text" name="TimeQuantityFrecuency" className="form-control" value={sev.bean.TimeQuantityFrecuency} onChange={sev.handleChange} />
                                </div>
                                <div className="col-md-12">
                                    <label>Descripción Común del Medicamento</label>
                                    <textarea name="CommonMedicationDescription" className="form-control" value={sev.bean.CommonMedicationDescription} onChange={sev.handleChange} />
                                </div>
                            </>
                        )}
                        {sev.bean.TechnologyType == 34 && (
                            <>
                                <div className="col-md-12">
                                    <label>DISPOSITIVO MÉDICO</label>
                                </div>
                                <div className="col-md-12">
                                    <MedicalDeviceEditor render={sev.bean.MedicalDeviceName} idSelector={sev.bean.IDMedicalDevice} onChange={(e) => { sev.setBean({ ...sev.bean, "IDMedicalDevice": e.IDMedicalDevice, "MedicalDeviceName": e.Name }) }} returnType="Object" />
                                </div>
                            </>
                        )}
                        {sev.bean.TechnologyType == 35 && (
                            <>
                                <div className="col-md-12">
                                    <label>COMPONENTES DEL CUERPO</label>
                                </div>
                                <div className="col-md-12">
                                    <BodyComponentEditor render={sev.bean.BodyComponentName} idSelector={sev.bean.IDBodyComponent} onChange={(e) => { sev.setBean({ ...sev.bean, "IDBodyComponent": e.IDBodyComponent, "BodyComponentName": e.Name }) }} returnType="Object" />
                                </div>
                            </>
                        )}
                        {sev.bean.TechnologyType == 27 && (
                            <>
                                <div className="col-md-12">
                                    <label>SUMINISTROS</label>
                                </div>
                                <div className="col-md-12">
                                    <HealthProductEditor render={sev.bean.HealthProductName} idSelector={sev.bean.IDHealthProduct} onChange={(e) => { sev.setBean({ ...sev.bean, "IDHealthProduct": e.IDHealthProduct, "HealthProductName": e.Name }) }} returnType="Object" />
                                </div>
                            </>
                        )}
                        {sev.bean.TechnologyType == 28 && (
                            <>
                                <div className="col-md-12">
                                    <label>OTROS</label>
                                </div>
                                <div className="col-md-12">
                                    <label>Código Otras Tecnologías</label>
                                    <input type="text" name="OtherTechologyCode" className="form-control" value={sev.bean.OtherTechologyCode} onChange={sev.handleChange} />
                                </div>
                            </>
                        )}
                        <div className="col-md-12">
                            <HealthTechnologyPurposeEditor render={sev.bean.HealthTechnologyPurposeName} idSelector={sev.bean.IDHealthTechnologyPurpose} onChange={(e) => { sev.setBean({ ...sev.bean, "IDHealthTechnologyPurpose": e.IDHealthTechnologyPurpose, "HealthTechnologyPurposeName": e.Name }) }} returnType="Object" />
                        </div>
                        <div className="col-md-12">
                            <label>Descripción</label>
                            <textarea name="Description" className="form-control" value={sev.bean.Description} onChange={sev.handleChange} />
                        </div>
                    </div>
                </Modal>
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item {sev.bean.Name}</strong>
                </ModalConfirm>
            </div>

        </div>

    )
}